import React, { FunctionComponent } from "react";

export const FontReset: FunctionComponent = ({ children }) => (
    <div style={{ fontFamily: "serif" }}>
        {children}
    </div>
)
